import React from 'react'
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import '../Style/About.css'

function About() {
  return (
    <div>


        <div className='team'>
        <h2>Managing your finances can bring several benefits, including: </h2>
        
<ul>
    <li>Control over your money: By managing your finances, you can take control of your money and make informed decisions about how to allocate your income towards your expenses, savings, and financial goals.
</li>
    <li>Reduced financial stress: When you have a plan for your money, you are less likely to experience financial stress and worry. You'll be better prepared to handle unexpected expenses and emergencies.
</li>
    <li>Improved credit score: By managing your finances and paying your bills on time, you can improve your credit score, which can make it easier to qualify for loans, credit cards, and other financial products.
</li>
    <li>Increased savings: When you manage your finances effectively, you can identify areas where you can cut back on expenses and increase your savings. This can help you build an emergency fund, save for a down payment on a home, or plan for retirement.
</li>
          </ul>
        </div>
    </div>
  )
}

export default About;